import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAvailableEvidence, IEvidenceRequest } from '@core/interfaces/iportfolio';
import { PortfolioService } from '@core/services/portfolio.service';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-request-evidence',
    templateUrl: './request-evidence.component.html',
    styleUrls: ['./request-evidence.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RequestEvidenceComponent {
  isProcessing: boolean = false;
  comment: string | undefined = undefined;

  constructor(
    private portfolioService: PortfolioService,
    public dialogRef: MatDialogRef<RequestEvidenceComponent>,
    @Inject(MAT_DIALOG_DATA) public editData: IAvailableEvidence,
    private translocoService: TranslocoService
  ) { }

  onSubmit(): void {
    if (!this.editData) return;

    this.isProcessing = true;
    const payload: IEvidenceRequest  = {
      fromStudentClassEnrollmentID: this.editData.fromStudentClassEnrollmentID,
      toStudentClassEnrollmentID: this.editData.toStudentClassEnrollmentID ?? 0,
      studentId: this.editData.studentId ?? 0,
      comment: this.comment
    };

    const successMessage = this.translocoService.translate('user.dashboard.portfolio.requestEvidence.sentToast');
    this.portfolioService.processEvidenceRequest(payload, successMessage)
      .pipe(take(1)).subscribe((res: boolean) => { 
        if (res) {
          this.isProcessing = false; 
          this.dialogRef.close();
        }
      });
  }
}
